export default {
  skin: 'default',
  skins: {
  },
  config: {
    tabs: {
      cois: true,
      audits: true,
      certificates: true,
      documents: true
    }
  }
}
